import { cn } from '@/lib/utils';
import { Button, ButtonProps } from '../shadcn/button';
import Image from 'next/image';
import * as React from 'react';

export interface IconButtonProps extends ButtonProps {
  src: string;
  imgClassName?: string;
}

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, imgClassName, src, ...props }, ref) => {
    return (
      <Button
        size='icon-lg'
        variant='secondary'
        ref={ref}
        className={cn('border-border hover:bg-border', className)}
        {...props}
      >
        <Image className={imgClassName} src={src} alt='' />
      </Button>
    );
  }
);
IconButton.displayName = 'IconButton';

export { IconButton };
